import { createAction, props } from '@ngrx/store';

export namespace HemsActions {
  export enum Type {
    SET_HEMS_GATEWAY_SERIAL = '[HEMS] Set HEMS Gateway Serial',
  }

  export const setHemsGatewaySerial = createAction(
    Type.SET_HEMS_GATEWAY_SERIAL,
    props<{
      gatewaySerial: string;
    }>()
  );
}
